export const OverlayStyle = `w-full h-full fixed top-0 left-0 bg-black bg-opacity-40 z-30`;
